<template>
  <v-container fluid class="login-page pa-0 d-flex align-center justify-center">
    <div class="auth-frame">
      <v-row no-gutters class="fill-height">
        <!-- LEFT: OTP form -->
        <v-col cols="12" md="6" class="d-flex align-center justify-center form-panel pa-8 pa-md-12">
          <div class="form-inner">
            <v-img
              class="mb-8"
              height="40"
              max-width="130"
              src="../../assets/logo.png"
            ></v-img>

            <div class="mb-8">
              <div class="welcome-text">OTP Verification</div>
              <div class="sub-text">
                Enter the code sent to your email/phone
              </div>
            </div>

            <v-form ref="resetForm" v-model="isValid">
              <span class="field-label">OTP Code</span>
              <v-text-field
                class="mt-2 pill-field otp-field"
                ref="otp"
                :rules="rules.otp"
                v-model="formData.otp"
                density="comfortable"
                placeholder="Enter 6-digit code"
                type="text"
                inputmode="numeric"
                maxlength="6"
                variant="solo"
                flat
                rounded="pill"
                bg-color="#f5f5f8"
                @keydown.enter="Request()"
              />
            </v-form>

            <v-btn
              @click="Request()"
              block
              size="large"
              rounded="pill"
              class="text-none text-subtitle-1 login-btn mt-4"
              elevation="0"
              variant="flat"
              :loading="submitting"
            >
              <span class="login--text">Submit</span>
            </v-btn>

            <div class="resend-row mt-5">
              <span class="resend-text">Didn't get the code?</span>
              <v-btn
                @click="ResendOtp()"
                text
                variant="text"
                class="text-none resend-btn"
                :disabled="resendCooldown > 0 || resending"
                :loading="resending"
              >
                <span v-if="resendCooldown > 0">
                  Resend in {{ resendCooldown }}s
                </span>
                <span v-else>Resend OTP</span>
              </v-btn>
            </div>

            <div class="text-center mt-2">
              <v-btn
                :to="{ name: 'signIn' }"
                text
                class="text-none text-subtitle-2 forgot-btn"
                variant="text"
              >
                <v-icon size="16" class="mr-1">mdi-arrow-left</v-icon>
                <span class="forgot--text">Back to Login</span>
              </v-btn>
            </div>
          </div>
        </v-col>

        <!-- RIGHT: Photo panel -->
        <v-col cols="12" md="6" class="d-none d-md-flex photo-panel">
          <div class="photo-bg"></div>
          <div class="photo-scrim"></div>

          <div class="float-card notification-card">
            <div class="notif-dot"></div>
            <div>
              <div class="notif-title">Code Sent</div>
              <div class="notif-sub">Check your inbox &middot; just now</div>
            </div>
          </div>

          <div class="photo-caption">
            <div class="caption-title">Almost there.</div>
            <div class="caption-sub">
              Verify your identity to securely access your dashboard.
            </div>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-dialog v-model="dialog" max-width="420" persistent>
      <v-card class="pa-4 text-center" rounded="xl">
        <v-card-text>
          Please wait, redirecting you back to the login page&hellip;
        </v-card-text>
        <v-card-actions class="justify-center">
          <div class="ball"></div>
          <div class="ball"></div>
          <div class="ball"></div>
          <div class="ball"></div>
          <div class="ball"></div>
        </v-card-actions>
        <v-progress-linear
          class="mx-2 mt-2"
          color="teal"
          indeterminate
        ></v-progress-linear>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import eventBus from "@/utils/eventBus";
export default {
  name: "otpLogin",

  data() {
    return {
      dialog: false,
      isValid: false,
      loginState: false,
      screenSize: "",
      visible: false,
      submitting: false,
      resending: false,
      resendCooldown: 0,
      resendTimer: null,
      formData: {
        otp: "",
      },
      showPassword: false,
      rules: {
        required: [(value) => !!value || "Required."],
        email: [
          (value) => !!value || "Required.",
          (value) => /.+@.+\..+/.test(value) || "Invalid email address.",
        ],
        otp: [
          (value) => !!value || "Required.",
          (value) => /^\d{4,6}$/.test(value) || "Enter a valid OTP code.",
        ],
      },
    };
  },

  computed: {},

  mounted() {
    eventBus.on("redirectback", () => {
      this.$router.push({ name: "signIn" });
    });
    // Start cooldown immediately on load since an OTP was just sent
    // to reach this screen (adjust if that's not the case).
    this.startResendCooldown();
  },

  beforeUnmount() {
    if (this.resendTimer) clearInterval(this.resendTimer);
  },

  methods: {
    Request() {
      if (!this.isValid) {
        this.$refs.resetForm.validate();
      } else {
        this.submitting = true;
        const allData = {
          otp: this.formData.otp,
          user_id: localStorage.getItem("otp_token"),
        };
        this.$store
          .dispatch("auth/VERIFYOtp", allData)
          .finally(() => {
            this.submitting = false;
          });
      }
    },

    ResendOtp() {
      if (this.resendCooldown > 0 || this.resending) return;
      this.resending = true;

      const payload = {
        user_id: localStorage.getItem("otp_token"),
      };

      this.$store
        .dispatch("auth/RESENDOtp", payload)
        .then(() => {
          this.startResendCooldown();
        })
        .finally(() => {
          this.resending = false;
        });
    },

    startResendCooldown(seconds = 60) {
      this.resendCooldown = seconds;
      if (this.resendTimer) clearInterval(this.resendTimer);
      this.resendTimer = setInterval(() => {
        if (this.resendCooldown > 0) {
          this.resendCooldown -= 1;
        } else {
          clearInterval(this.resendTimer);
        }
      }, 1000);
    },

    checkScreenSize() {
      const isSmallScreen = window.matchMedia("(max-width: 768px)").matches;
      this.screenSize = isSmallScreen ? "Small" : "Large";
    },
  },

  watch: {},
};
</script>

<style>
/* @import url("../authStyle.css"); */
</style>

<style scoped>
.login-page {
  min-height: 100vh;
  background: #eceef2;
  padding: 32px !important;
}

.auth-frame {
  width: 100%;
  max-width: 1100px;
  height: 640px;
  max-height: 92vh;
  border-radius: 32px;
  overflow: hidden;
  box-shadow: 0 30px 60px -20px rgba(45, 42, 74, 0.25);
  background: #fff;
}

.fill-height {
  height: 100%;
}

/* ---------- LEFT: FORM ---------- */
.form-panel {
  height: 100%;
  background: #fff;
}

.form-inner {
  width: 100%;
  max-width: 340px;
}

.welcome-text {
  font-size: 26px;
  font-weight: 700;
  color: #2d2a4a;
}

.sub-text {
  font-size: 14px;
  color: #8a8a9a;
  margin-top: 4px;
}

.field-label {
  font-size: 13px;
  font-weight: 600;
  color: #4a4a5a;
}

.pill-field :deep(.v-field) {
  box-shadow: none;
}

.otp-field :deep(input) {
  letter-spacing: 6px;
  font-weight: 700;
  font-size: 18px;
}

.login-btn {
  height: 48px !important;
  font-weight: 700;
  letter-spacing: 0.3px;
  background: #f4c542 !important;
  color: #2d2a4a !important;
}

.login-btn:hover {
  background: #f0b92b !important;
}

.resend-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex-wrap: wrap;
}

.resend-text {
  font-size: 13px;
  color: #8a8a9a;
}

.resend-btn {
  font-size: 13px;
  font-weight: 700;
  color: #50568e !important;
  padding: 0 4px !important;
  min-width: 0 !important;
}

.forgot-btn {
  opacity: 0.8;
  color: #6b6b80 !important;
}

.forgot-btn:hover {
  opacity: 1;
}

/* ---------- RIGHT: PHOTO PANEL ---------- */
.photo-panel {
  position: relative;
  height: 100%;
  overflow: hidden;
  padding: 20px;
}

.photo-bg {
  position: absolute;
  inset: 20px;
  border-radius: 24px;
  background: linear-gradient(150deg, #3f4478 0%, #50568e 55%, #6b70b3 100%);
  /* Swap for a real photo:
     background: url('./team-photo.jpg') center/cover no-repeat;
  */
}

.photo-scrim {
  position: absolute;
  inset: 20px;
  border-radius: 24px;
  background: linear-gradient(to top, rgba(30, 28, 55, 0.55) 0%, rgba(30, 28, 55, 0) 45%);
}

.float-card {
  position: absolute;
  z-index: 3;
  background: #fff;
  border-radius: 16px;
  padding: 12px 16px;
  box-shadow: 0 12px 28px -8px rgba(20, 20, 40, 0.25);
}

.notification-card {
  top: 48px;
  left: 40px;
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 210px;
}

.notif-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #4caf50;
  flex-shrink: 0;
}

.notif-title {
  font-size: 13px;
  font-weight: 700;
  color: #2d2a4a;
}

.notif-sub {
  font-size: 11px;
  color: #9a9aa8;
  margin-top: 2px;
}

.photo-caption {
  position: absolute;
  bottom: 44px;
  left: 40px;
  right: 40px;
  z-index: 3;
  color: #fff;
}

.caption-title {
  font-size: 26px;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 8px;
}

.caption-sub {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
  max-width: 320px;
}

.ball {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #50568e;
  margin: 0 4px;
  display: inline-block;
  animation: bounce 1.2s infinite ease-in-out;
}
.ball:nth-child(2) { animation-delay: 0.1s; }
.ball:nth-child(3) { animation-delay: 0.2s; }
.ball:nth-child(4) { animation-delay: 0.3s; }
.ball:nth-child(5) { animation-delay: 0.4s; }

@keyframes bounce {
  0%, 80%, 100% { transform: scale(0.6); opacity: 0.5; }
  40% { transform: scale(1); opacity: 1; }
}
</style>